import { LitElement, html, css } from 'lit'

export class CartCount extends LitElement {
  static styles = [
    css`
      .cart_count {
        display: flex;
        height: 25px;
        justify-content: center;
        align-items: center;
        color: #0a0a0a;
        font-size: 14px;
        margin-left: 4px;
        position: absolute;
        transform: translateY(-50%);
      }
    `,
  ]

  static properties = {
    count: { type: Number },
    hideWhenZero: { type: Boolean, attribute: 'hide-when-zero' },
  }

  constructor() {
    super()

    window.MicroBus.on('count-change', (e) => {
      this.count = e.detail.count
    })
  }

  render() {
    return this.hideWhenZero && this.count === 0 ? html`` : html`<div class="cart_count">${this.count}</div>`
  }
}

customElements.define('cart-count', CartCount)
